import axios from "axios";
import {API_CSRF_URL} from "./apiUrlList";

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,   // sends the session cookie
});
 
// Fetch the token once and cache it on the instance.
let csrfReady = null;
async function ensureCsrf() {
  if (!csrfReady) {
    csrfReady = api.get(API_CSRF_URL).then(({ data }) => {
      api.defaults.headers.common[data.headerName] = data.token; // "X-XSRF-TOKEN"
    });
  }
  return csrfReady;
}
 
// Attach token before every mutating request; refresh once on 403.
api.interceptors.request.use(async (config) => {
  const m = (config.method || "get").toLowerCase();
  if (["post", "put", "patch", "delete"].includes(m)) {
    await ensureCsrf();
    config.headers["X-XSRF-TOKEN"] = api.defaults.headers.common["X-XSRF-TOKEN"];
  }
  return config;
});
 
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    if (error.response?.status === 403 && !error.config.__retried) {
      error.config.__retried = true;
      csrfReady = null;            // force a fresh token
      await ensureCsrf();
      error.config.headers["X-XSRF-TOKEN"] = api.defaults.headers.common["X-XSRF-TOKEN"];
      return api.request(error.config);
    }
    return Promise.reject(error);
  }
);